import { render, staticRenderFns } from "./Editar-venta.vue?vue&type=template&id=2a7e11f8"
import script from "./Editar-venta.vue?vue&type=script&lang=js"
export * from "./Editar-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports